import {FormLayout} from '../../../types/createStylesParams'
import {LayoutSize} from '../../../components-shared/LayoutSizeProvider/types'

export const getEffectiveFormLayout = ({
  layoutSize,
  formLayout,
}: {
  layoutSize: LayoutSize
  formLayout: FormLayout
}) =>
  layoutSize === LayoutSize.XS || layoutSize === LayoutSize.S || formLayout === FormLayout.Packed
    ? FormLayout.Packed
    : FormLayout.Strip
